import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={6} cy={6} r={4} fill="#90CAF9" />
  </svg>
);
export default SVGComponent;
